import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-[360px] w-full h-full flex flex-col mt-8 px-2">
      <h2 className="text-lg">Not Found</h2>
      <p className="text-md mt-4 font-serif">Could not find requested resource</p>
      <Link
        to="/"
        className="relative text-gray-800 transition-all duration-200 ease-in hover:text-gray-900 border-[1px] border-dashed px-6 py-2 rounded-md mt-12 hover:shadow-md hover:shadow-gray-500/30 max-w-fit hover:no-underline!"
      >
        Return Home
      </Link>
    </div>
  );
}
